import {SecurityInformationStore} from "../../../security/info/store/SecurityInformationStore";
import {TechnicalIndicatorsStore} from "../../../technical-indicators/store/TechnicalIndicatorsStore";
import {SecurityMapOf} from "../../../security/common/map/SecurityMap";
import {CompanyStatisticsViewModel} from "../../components/stats/models/CompanyStatisticsViewModel";
import {Observable} from "rxjs";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";
import {QuoteStore} from "../../../quote/store/QuoteStore";
import {buildQuoteRequest} from "../../../quote/util/QuoteStoreUtil";

export class CompanyStatisticsStore {

    public static readonly id = "companyStatisticsStore";

    private readonly sources = SecurityMapOf<Observable<CompanyStatisticsViewModel>>();

    /** @ngInject */
    public constructor(private readonly quoteStore: QuoteStore,
                       private readonly securityInformationStore: SecurityInformationStore,
                       private readonly technicalIndicatorsStore: TechnicalIndicatorsStore) {
    }

    public stream(security: CodeAndExchange): Observable<CompanyStatisticsViewModel> {
        return this.sources.computeIfAbsent(security, (sec) => this.buildModel(sec));
    }

    private buildModel(security: CodeAndExchange): Observable<CompanyStatisticsViewModel> {
        const quoteRequest = buildQuoteRequest(security);
        const quote$ = this.quoteStore
                           .stream(quoteRequest)
                           .startWith(null);

        const securityInfo$ = this.securityInformationStore
                                  .stream(security)
                                  .startWith(null);

        const indicators$ = this.technicalIndicatorsStore
                                .stream(security)
                                .startWith(null);

        return Observable.combineLatest(quote$, securityInfo$, indicators$)
                         .auditTime(100)
                         .map(([quote, info, indicators]) => CompanyStatisticsViewModel.create(security,
                                                                                               quote,
                                                                                               info,
                                                                                               indicators))
                         .publishReplay(1)
                         .refCount();
    }
}
